import { html } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { infrastructure } from '../infrastructure.js';
import '../components/ApiTester.js';

/**
 * @param {UrlSearchParams} query - object representing query parameters
 * @returns {TemplateResult}
 */
export default function renderApiTester({ query }) {
  return html`
    <osk-api-tester .infrastructure=${infrastructure} .query=${query}></osk-api-tester>
  `;
}
